import semver from 'semver'

export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

export function sanitizeReverse (value) {
  return value
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
}

export function getParsedVersion (version) {
  version = version.split('-')[0]
  if (semver.valid(version) === null) {
    version = version.split('.').slice(1).join('.')
  }
  return version
}

export function toCsv ({ keys = null, data = null, columnDelimiter = ',', lineDelimiter = '\n' }) {
  if (data === null || !data.length) {
    return null
  }

  let result = ''
  result += keys.join(columnDelimiter)
  result += lineDelimiter

  data.forEach(item => {
    keys.forEach(key => {
      if (item[key] === undefined) {
        item[key] = ''
      }
      result += typeof item[key] === 'string' && item[key].includes(columnDelimiter) ? `"${item[key]}"` : item[key]
      result += columnDelimiter
    })
    result = result.slice(0, -1)
    result += lineDelimiter
  })

  return result
}

export function isValidIPv4Cidr (rule, value) {
  return new Promise((resolve, reject) => {
    if (!value) {
      reject(new Error())
      return
    }
    const cidrRegex = /^(\d{1,3}\.){3}\d{1,3}\/([0-9]|[1-2][0-9]|3[0-2])$/
    if (!cidrRegex.test(value)) {
      reject(new Error('Invalid CIDR format'))
      return
    }
    const ip = value.split('/')[0]
    const octets = ip.split('.').map(Number)
    if (octets.some(octet => octet < 0 || octet > 255)) {
      reject(new Error('Invalid CIDR format'))
      return
    }
    resolve()
  })
}


export function getPricing() {
  return [                
    { key:1, name:'gen3.xs', vcpu: '1', ram: '4', pvpmonth: 28.00 ,pvphour: 0.038 },
    { key:2, name:'gen3.small', vcpu: '2', ram: '8', pvpmonth: 56.00 , pvphour: 0.077 },
    { key:3, name:'gen3.medium', vcpu: '4', ram: '16', pvpmonth: 112.00, pvphour: 0.153 },
    { key:4, name:'gen3.large', vcpu: '8', ram: '32', pvpmonth: 224.00, pvphour: 0.307 },
    { key:5, name:'gen3.xlarge', vcpu: '16', ram: '64', pvpmonth: 448.00, pvphour: 0.614 },
    { key:6, name:'gen3.2xlarge', vcpu: '32', ram: '128', pvpmonth: 896.00, pvphour: 1.227 },
    { key:7, name:'gen3.4xlarge', vcpu: '48', ram: '192', pvpmonth: 1344.00, pvphour: 1.841 },
    { key:8, name:'cpu3.xs', vcpu: '1', ram: '2', pvpmonth: 18.00, pvphour: 0.025 },
    { key:9, name:'cpu3.small', vcpu: '2', ram: '4', pvpmonth: 36.00, pvphour: 0.049},
    { key:10, name:'cpu3.medium', vcpu: '4', ram: '8', pvpmonth: 72.00, pvphour: 0.099 },
    { key:11, name:'cpu3.large', vcpu: '8', ram: '16', pvpmonth: 144.00, pvphour: 0.197 },
    { key:12, name:'cpu3.xlarge', vcpu: '16', ram: '32', pvpmonth: 288.00, pvphour: 0.395 },
    { key:13, name:'cpu3.2xlarge', vcpu: '32', ram: '64', pvpmonth: 576.00, pvphour: 0.789 },
    { key:14, name:'cpu3.4xlarge', vcpu: '48', ram: '96', pvpmonth: 864.00, pvphour: 1.184 },
    { key:15, name:'mem3.xs', vcpu: '1', ram: '8', pvpmonth:  48.00, pvphour: 0.066 },
    { key:16, name:'mem3.small', vcpu: '2', ram: '16', pvpmonth: 96.00, pvphour: 0.132 },
    { key:17, name:'mem3.medium', vcpu: '4', ram: '32', pvpmonth: 192.00 , pvphour: 0.263 },
    { key:18, name:'mem3.large', vcpu: '8', ram: '64', pvpmonth: 384.00, pvphour: 0.526 },
    { key:19, name:'mem3.xlarge', vcpu: '16', ram: '128', pvpmonth: 768.00, pvphour: 1.052 },
    { key:20, name:'mem3.2xlarge', vcpu: '32', ram: '256', pvpmonth: 1536.00, pvphour: 2.104 },
    { key:21, name:'mem3.4xlarge', vcpu: '48', ram: '384', pvpmonth: 2304.00, pvphour: 3.156 },
  ]
}

export function getCustomPricingMonth(vcpu, ram, nvme, 
  ssd, hdd, backup,
  buckets, xfer, ipv4,
  loadbal, k8s) {
    let price_out = 0
    let price_base = {
      vcpu: 8,
      ram: 5,
      nvme: 0.130,
      ssd: 0.090,
      hdd: 0.050,
      backup: 0.050,
      buckets: 0.130,
      xfer: 0.001,
      ipv4: 5,
      loadbal: 9,
      k8s: 60,
    }
    if (Number(vcpu) > 0)
      price_out+= vcpu * price_base.vcpu
    if (Number(ram) > 0)
      price_out+= ram * price_base.ram
    if (Number(nvme) > 0)
      price_out+= nvme * price_base.nvme
    if (Number(ssd) > 0)
      price_out+= ssd * price_base.ssd
    if (Number(hdd) > 0)
      price_out+= hdd * price_base.hdd
    if (Number(backup) > 0)
      price_out+= backup * price_base.backup
    if (Number(buckets) > 0)
      price_out+= buckets * price_base.buckets
    if (Number(ipv4) > 0)
      price_out+= ipv4 * price_base.ipv4
    if (Number(xfer) > 0)
      price_out+= xfer * price_base.xfer
    if (Number(loadbal) > 0)
      price_out+= loadbal * price_base.loadbal
    if (Number(k8s) > 0)
      price_out+= k8s * price_base.k8s
    
    if (price_out > 0)
      return (Math.round((price_out + Number.EPSILON) * 100) / 100).toFixed(2)
    
    return '-EINVAL'
  }
  
  
  export function getCustomPricingHour(vcpu, ram, nvme, 
    ssd, hdd, backup,
    buckets, xfer, ipv4,
    loadbal, k8s) {
      let price_out = 0
      let price_base = {
        vcpu: 0.01096,
        ram: 0.00685,
        nvme: 0.00018,
        ssd: 0.00012,
        hdd: 0.00007,
        backup: 0.00007,
        buckets: 0.00018,
        xfer: 0.0000137,
        ipv4: 0.00685,
        loadbal: 0.01233,
        k8s: 0.08219,
      }
      if (Number(vcpu) > 0)
        price_out+= vcpu * price_base.vcpu
      if (Number(ram) > 0)
        price_out+= ram * price_base.ram
      if (Number(nvme) > 0)
        price_out+= nvme * price_base.nvme
      if (Number(ssd) > 0)
        price_out+= ssd * price_base.ssd
      if (Number(hdd) > 0)
        price_out+= hdd * price_base.hdd
      if (Number(backup) > 0)
        price_out+= backup * price_base.backup
      if (Number(buckets) > 0)
        price_out+= buckets * price_base.buckets
      if (Number(ipv4) > 0)
        price_out+= ipv4 * price_base.ipv4
      if (Number(xfer) > 0)
        price_out+= xfer * price_base.xfer
      if (Number(loadbal) > 0)
        price_out+= loadbal * price_base.loadbal
      if (Number(k8s) > 0)
        price_out+= k8s * price_base.k8s
      
      if (price_out > 0)
        return (Math.round((price_out + Number.EPSILON) * 100) / 100).toFixed(2)
      
      return '-EINVAL'
    }